import { Desktop } from "./Desktop";
import { Mobile } from "./Mobile";
import useCookie from "~/hooks/useCookie";
import { Logger } from "~/utils/logger";
const logger = new Logger("signin", "info");

export function Signin(props: {
  color?: string;
  bg_color?: string;
  type: "desktop" | "mobile";
}) {
  logger.debug("props: ", props);

  const userName = useCookie("CNNAME");

  if (props.type === "mobile") {
    return (
      <Mobile
        userName={userName}
        color={props.color}
        backgroundColor={props.bg_color}
      />
    );
  }

  return (
    <Desktop
      userName={userName}
      color={props.color}
      backgroundColor={props.bg_color}
    />
  );
}
